import React, {useState, useEffect} from 'react';
import Navbar1 from './Navbar1';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    doc,
    getDoc,
    serverTimestamp,
    setDoc
  } from "firebase/firestore";
import { db, storage } from "../../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { toast } from 'react-toastify';
import {Document, Page, pdfjs} from 'react-pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import { reset } from '../../features/auth/authSlice';
import Sidebar from './Sidebar';
import Spinner from '../Spinner';


let id = '';

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const Step4 = () => {
    const { t } = useTranslation();
    if(localStorage.getItem('id') != null){
        id = localStorage.getItem('id');
    }
    var today = Date();
    var lastDay = '01/30/2023';

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const type = localStorage.getItem("type");
    const [form, setError] = useState({
        error: false,
    });

    const [calendar, setCalendar] = useState("");
    const [calendarUrl, setCalendarUrl] = useState("");

    const [budget, setBudget] = useState("");
    const [budgetUrl, setBudgetUrl] = useState("");

    const [matrix, setMatrix] = useState("");
    const [matrixUrl, setMatrixUrl] = useState("");
    
    const [pageNumber, setPageNumber] = useState(1);

    const [per, setPerc] = useState(0);

    const [isLoading, setIsLoading] = useState(false);

    const [page, setUpdated] = useState({
        updated: false,
    });

    const [status, setEnabled] = useState({
        submitted: false,
    });

    const [deadline, setDeadline] = useState({
        isPassed: true,
        value: true
    });

    let [firstRender, setFirstRender] = useState({
        firstRender: true,
    });

    const [act, setActWord] = useState({
        count: 0
    });
    
    const actWordCount = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        
        act.count = value.trim().split(' ').length;
        if(1000 - act.count < 0){
            form.error = true;
            setError({...form, [form]:true})
        }
        else{
            form.error = false;
            setError({...form, [form]:false})
        }
        setActWord({...act, [name]:value})
    }

    const [plan, setPlanWord] = useState({
        count: 0
    });
    
    const planWordCount = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        
        plan.count = value.trim().split(' ').length;
        if(1000 - plan.count < 0){
            form.error = true;
            setError({...form, [form]:true})
        }
        else{
            form.error = false;
            setError({...form, [form]:false})
        }
        setPlanWord({...plan, [name]:value})
    }

    const [mat, setMatWord] = useState({
        count: 0
    });
    
    const matWordCount = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        
        mat.count = value.trim().split(' ').length;
        if(300 - mat.count < 0){
            form.error = true;
            setError({...form, [form]:true})
        }
        else{
            form.error = false;
            setError({...form, [form]:false})
        }
        setMatWord({...mat, [name]:value})
    }

    const [step, setStep] = useState({
        activities : '',
        calendarUrl : '',
        matrixUrl: '',
        budgetUrl: ''
    });
    
    const getStatus = async () => {
        try {
            const userRef = doc(db, "submissions", id);
            const userSnap = await getDoc(userRef);
            
            if(userSnap.exists()){
                status.submitted = true;
                setEnabled({...status, [status]:true})
            }
            
        } catch (error) {
            console.log(error);
        }
    };

    const getStepDetails = async () => {
        try {
            const stepRef = doc(db, "step4", id);
            const stepSnap = await getDoc(stepRef);
            
            if(stepSnap.exists()){
            return stepSnap.data();
            }
            else{
            return null;
            }
        } catch (error) {
            if(error.toString().includes("offline")){
                window.alert('Pas de connexion internet')
            }
            else{
                window.alert(error)
            }
        }
    };

    const { stp, isError, isSuccess, message} = useSelector(
        (state) => state.auth
      )

    useEffect(() => {
        // restrict access for examinators
        if(type === 'exam'){
            navigate('/admin')
        }
        
        // getting step details
        if(firstRender){
            deadline.isPassed = Date.parse(today) > Date.parse(lastDay);
            deadline.value = Math.round((Date.parse(lastDay) - Date.parse(today)) / (1000 * 60 * 60 * 24));
            setDeadline(deadline);
            getStatus();
            getStepDetails().then(data => {
                if(data != null){
                    setCalendarUrl(data.calendarUrl);
                    setMatrixUrl(data.matrixUrl);
                    setBudgetUrl(data.budgetUrl)
                    setStep(data);
                    setFirstRender(false);
                }
            });
        }

        if (isError) {
        toast.error(message)
        }

        if (isSuccess || stp) {
            navigate("/step5")
        }
        dispatch(reset())
  }, [step, isError, isSuccess, message, firstRender, dispatch])

  const uploadCalendar = () => {
    const name = new Date().getTime() + calendar.name;

    console.log(name);
    if(!calendar){
        window.alert('Veuillez choisir le fichier à enregistrer');
    }
    else{
        const storageRef = ref(storage, `/files/${calendar.name}`);
        const uploadTask = uploadBytesResumable(storageRef, calendar);

        uploadTask.on(
        "state_changed",
        (snapshot) => {
            const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            if(progress === 100){
                window.alert("Enregistré !");
            }
            setPerc(progress);
            switch (snapshot.state) {
            case "paused":
                console.log("Upload is paused");
                break;
            case "running":
                console.log("Upload is running");
                break;
            default:
                break;
            }
        },
        (error) => {
            console.log(error);
        },
        () => {
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) =>{
            setCalendarUrl(downloadURL)
            });
        }
        );
    }
  };

  const uploadMatrix = () => {
    const name = new Date().getTime() + matrix.name;

    console.log(name);
    if(!matrix){
        window.alert('Veuillez choisir le fichier à enregistrer');
    }
    else{
        const storageRef = ref(storage, `/files/${matrix.name}`);
        const uploadTask = uploadBytesResumable(storageRef, matrix);

        uploadTask.on(
        "state_changed",
        (snapshot) => {
            const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            if(progress === 100){
                window.alert("Enregistré !");
            }
            setPerc(progress);
            switch (snapshot.state) {
            case "paused":
                console.log("Upload is paused");
                break;
            case "running":
                console.log("Upload is running");
                break;
            default:
                break;
            }
        },
        (error) => {
            console.log(error);
        },
        () => {
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) =>{
            setMatrixUrl(downloadURL)
            });
        }
        );
    }
  };

  const uploadBudget = () => {
    const name = new Date().getTime() + budget.name;

    console.log(name);
    if(!budget){
        window.alert('Veuillez choisir le fichier à enregistrer');
    }
    else{
        const storageRef = ref(storage, `/files/${budget.name}`);
        const uploadTask = uploadBytesResumable(storageRef, budget);

        uploadTask.on(
        "state_changed",
        (snapshot) => {
            const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            if(progress === 100){
                window.alert("Enregistré !");
            }
            setPerc(progress);
            switch (snapshot.state) {
            case "paused":
                console.log("Upload is paused");
                break;
            case "running":
                console.log("Upload is running");
                break;
            default:
                break;
            }
        },
        (error) => {
            console.log(error);
        },
        () => {
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) =>{
            setBudgetUrl(downloadURL)
            });
        }
        );
    }
  };

    const handleInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        setStep({...step, [name]:value})
    }

    const handleCalendarInput = (event) => {
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        setCalendar(event.target.files[0]);
    }

    const handleMatrixInput = (event) => {
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        setMatrix(event.target.files[0]);
    }

    const handleBudgetInput = (event) => {
        if(!page.updated){
            page.updated = true;
            setUpdated({...page, [page]:true})
        }
        setBudget(event.target.files[0]);
    }

    // Handle Submit
    const handleSubmit = async (event) => {
        event.preventDefault();
        
        if(page.updated){
            if(window.confirm("Enregistrer les modifications ?")){
                setIsLoading(true);
                let {activities, planning, matrice, budget} = step;
                const stepData = {
                    activities,
                    matrixUrl,
                    calendarUrl,
                    budgetUrl
                }
                try {
                    await setDoc(doc(db, "step4", id), {
                    ...stepData,
                    timeStamp: serverTimestamp(),
                    });
                    navigate("/step5")
                } catch (error) {
                    setIsLoading(false);
                    if(error.toString().includes("offline")){
                        window.alert('Pas de connexion internet')
                    }
                    else{
                        window.alert(error)
                    }
                }
            }
        }
        else{
            navigate("/step5")
        }
    }

    const handleSave = async (event) => {
        event.preventDefault();
        
        if(page.updated){
            if(window.confirm("Enregistrer les modifications ?")){
                setIsLoading(true);
                let {activities, planning, matrice, budget} = step;
                const stepData = {
                    activities,
                    matrixUrl,
                    calendarUrl,
                    budgetUrl
                }
                try {
                    await setDoc(doc(db, "step4", id), {
                    ...stepData,
                    timeStamp: serverTimestamp(),
                    });
                    navigate("/dashboard")
                } catch (error) {
                    setIsLoading(false);
                    if(error.toString().includes("offline")){
                        window.alert('Pas de connexion internet')
                    }
                    else{
                        window.alert(error)
                    }
                }
            }
        }
        else{
            navigate("/dashboard")
        }
    }

    if (isLoading) {
        return <Spinner />
      }

    return (
        <div>
            <Navbar1/>
            <div className="container m-5">
                <div className="row">
                <div className='col-md-3 m-4'>
                        <div className="row cadre">
                            <p className="mt-3 pt-0 text-white fw-bolder" id="dashb">{t('application')}</p>
                            <div className="m-3 mt-0 mb-0">
                                <Sidebar/>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8 pl-4">
                        <p className="lead fs-1">{t('menu_4')}</p>
                        <p><span className="star">*</span> = {t('required')}</p>
                        <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label"><span className="star">*</span> {t('project_activities')} ({1000 - act.count} {t('remaining_words')})</label>
                                    <textarea className={1000 - act.count < 0?
                                        'error'
                                            :
                                        ''
                                    } name="activities" required disabled={status.submitted || deadline.value <= 0} value={step.activities} onChange={handleInput} id="exampleInputEmail1" onKeyDown={actWordCount} cols="100" rows="10"></textarea>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label me-2"><span className={calendarUrl.length   < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder text-success'
                                                }>{t('text_6_4')}</span> <span className="star">*</span>: </label>
                                    <br />
                                    <input type="file" disabled={status.submitted || deadline.value <= 0} accept='.pdf' onChange={handleCalendarInput} id="myfile" name="myfile"/>
                                    <input type="button" disabled={status.submitted || deadline.value <= 0} className='btn btn-outline-primary'  id="vehicle1" name="vehicle1" value={t('save')} onClick={uploadCalendar}/>
                                    <br />
                                    <a href={calendarUrl} target='_blank' rel='noreferrer'>{calendarUrl}</a>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label me-2"><span className={budgetUrl.length   < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder text-success'
                                                }>{t('matrix')}</span> <span className="star">*</span>: </label>
                                    <br />
                                    <input type="file" disabled={status.submitted || deadline.value <= 0} accept='.pdf' onChange={handleMatrixInput} id="myfile" name="myfile"/>
                                    <input type="button" disabled={status.submitted || deadline.value <= 0} className='btn btn-outline-primary'  id="vehicle1" name="vehicle1" value={t('save')} onClick={uploadMatrix}/>
                                    <br />
                                    <a href={matrixUrl} target='_blank' rel='noreferrer'>{matrixUrl}</a>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label me-2"><span className={budgetUrl.length   < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder text-success'
                                                }>{t('detailed_budget')}</span> <span className="star">*</span>: </label>
                                    <br />
                                    <input type="file" disabled={status.submitted || deadline.value <= 0} accept='.pdf' onChange={handleBudgetInput} id="myfile" name="myfile"/>
                                    <input type="button" disabled={status.submitted || deadline.value <= 0} className='btn btn-outline-primary'  id="vehicle1" name="vehicle1" value={t('save')} onClick={uploadBudget}/>
                                    <br />
                                    <a href={budgetUrl} target='_blank' rel='noreferrer'>{budgetUrl}</a>
                                </div>
                                
                                <div className="d-flex justify-content-between">
                                    <div className="col-md-8">
                                        <input type="submit" disabled={status.submitted || deadline.value <= 0} className='col-md-3 btn btn-primary'  id="vehicle1" name="vehicle1" value={t('previous')} onClick={()=>{navigate("/step3")}}/>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="d-flex justify-content-end">
                                            <div className="col-md-8">
                                                <input type="submit" disabled={form.error || status.submitted} className='col-md-8 btn btn-primary'  id="vehicle1" name="vehicle1" value={t('save')} onClick={handleSave}/>
                                            </div>
                                            <div className="col-md-4">
                                                <input type="submit" disabled={form.error || status.submitted} className='btn btn-outline-primary'  id="vehicle1" name="vehicle1" value={t('continue')} onClick={handleSubmit}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </form>
                    </div>
                </div>
                <div className="space"/>
            </div>
        </div>
    )
}

export default Step4;
